<template>
  <div class="text-divider-container">
    <v-divider></v-divider>
    <span class="text-divider__text">{{ text }}</span>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  name: 'text-divider',
  props: {
    text: String
  }
}
</script>
<style scoped>

a {
  color: black;
}

.text-divider-container {
  flex: 1;
  display: flex;
  margin-top: 24px;
  margin-bottom: 24px;
  align-items: center;
  justify-content: center;

  > hr {
    flex: 1 1 0
  }
}

.text-divider__text {
  margin: 0 10px;
  font-size: 12px;
  line-height: 16px;
  color: #979797;
}
</style>
